import type { ReactNode } from 'react';
import { useId } from 'react';
import { T } from 'gt-react';
import { Label } from 'src/components/ui/label';
import { Switch } from 'src/components/ui/switch';

export function IdentifyPartyOthersToggles({
  othersHelp,
  othersNoMatchHelp,
  enableOthers,
  othersEmitNullWhenNoMatch,
  onEnableOthersChange,
  onOthersEmitNullWhenNoMatchChange,
}: {
  othersHelp: ReactNode;
  othersNoMatchHelp: ReactNode;
  enableOthers: boolean;
  othersEmitNullWhenNoMatch: boolean;
  onEnableOthersChange: (checked: boolean) => void;
  onOthersEmitNullWhenNoMatchChange: (checked: boolean) => void;
}) {
  return (
    <>
      <IdentifyPartySwitchRow
        label={<T>Catch-all "Others" socket</T>}
        help={othersHelp}
        checked={enableOthers}
        onCheckedChange={onEnableOthersChange}
      />
      {enableOthers ? (
        <IdentifyPartySwitchRow
          label={<T>When nothing matches</T>}
          help={othersNoMatchHelp}
          checked={othersEmitNullWhenNoMatch}
          onCheckedChange={onOthersEmitNullWhenNoMatchChange}
        />
      ) : null}
    </>
  );
}

function IdentifyPartySwitchRow({
  label,
  help,
  checked,
  onCheckedChange,
}: {
  label: ReactNode;
  help: ReactNode;
  checked: boolean;
  onCheckedChange: (checked: boolean) => void;
}) {
  const id = useId();
  return (
    <div className="flex items-center justify-between rounded-md border p-3">
      <div className="space-y-0.5">
        <Label htmlFor={id} className="text-sm">
          {label}
        </Label>
        <p className="text-xs text-muted-foreground">{help}</p>
      </div>
      <Switch id={id} checked={checked} onCheckedChange={onCheckedChange} />
    </div>
  );
}
